<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.categoriePrestation') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="row">

                        <b-container>
                            <div class="card-body p-1em">
                                <h1 class="card-title text-center mb-0">
                                    {{ mCategory.nom }}
                                    <span class="ml-5" v-if="can">
                                        <b-button variant="primary" class="btn-sm" @click="updateCategoriePrestation">
                                        {{ $t('message.edit') }}
                                        </b-button>
                                        <b-button variant="danger" class="btn-sm" v-b-modal.delete-modal>
                                        {{ $t('message.delete') }}
                                    </b-button>
                                    </span>
                                </h1>
                            </div>

                            <b-row>
                                <b-col col sm="12">
                                    <h3>  {{ $t('message.listeDesPrestations') }} </h3>

                                    <!--<router-link :to="{ name: 'add-prestation', query:{categorie_id:categoriePrestation.id} }" v-if="can">
                                        {{ $t('message.add') }}

                                        <i class="fas fa-plus-circle edit-icon"></i>
                                    </router-link>-->
                                </b-col>
                                <b-col col sm="12">
                                    <section class="container" id="appointment-table">
                                        <div class="appointment-table-header my-2 mb-4">
                                            <b-button @click="handleOnAddClick" v-if="can">
                                                <i class="fa fa-plus edit-icon"></i>
                                                {{ $t('message.add') }}
                                            </b-button>

                                            <div class="d-inline-block ml-1 mr-5 width-270">
                                                <b-input-group
                                                        size="sm"
                                                        class="mb-3"
                                                >
                                                    <b-form-input
                                                            type="text"
                                                            size="sm"
                                                            class="p-2 h-100"
                                                            :placeholder="$t('message.filter') + '...'"
                                                            v-model="filterCriteria"
                                                    ></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button
                                                                size="sm"
                                                                text="Button"
                                                                variant="primary"
                                                                @click="handlerOnFilterButton"
                                                        >
                                                            Go
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>

                                                <div
                                                        v-if="paginationObject.numOfPages > 1"
                                                        class="pagination-wrapper d-inline-block"
                                                >
                                                    <div class="pagination">
                                                        <a
                                                                href="#"
                                                                :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('prev')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                        </a>
                                                        <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                            <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                            </template>
                                                            <template v-else>
                                                                <a
                                                                        href="#"
                                                                        :key="key"
                                                                        class="page-numbers"
                                                                        @click="_handlePaginationClick(pageNumber)"
                                                                >
                                                                    {{ pageNumber }}
                                                                </a>
                                                            </template>
                                                        </template>
                                                        <a
                                                                href="#"
                                                                class="next page-numbers"
                                                                :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('next')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row appointment-table-content">
                                            <div class="container-fluid">
                                                <template
                                                        v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                                                >
                                                    <div
                                                            v-for="(categoryPrestation, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                            :key="key"
                                                            class="row appointment-item hovered"
                                                            @click="onPrestationClick(categoryPrestation.slug)"
                                                    >
                                                        <div class="col-lg-8">
                                                        <span class="appointment-label">
                                                            {{ $t('message.nomEtablissement') }}
                                                        </span>
                                                            <h4 class="appointment-date">{{ categoryPrestation.name }}</h4>
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <span class="appointment-label">
                                                                {{ $t('message.price') }}
                                                            </span>
                                                            <h4>{{ _displayNumber(categoryPrestation.price) }}</h4>
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                                </template>

                                            </div>
                                        </div>
                                    </section>
                                    <!--<vue-good-table
                                            id="operation"
                                            :columns="prestationColumns"
                                            :rows="prestationRows"
                                            :search-options="{
                                                enabled:true,
                                                }"
                                            :pagination-options="paginationOptions"
                                            @on-row-click="onPrestationClick"
                                    />-->
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $t('message.categoriePrestation')"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mCategory.nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteCategoriePrestation">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';
	import { pagination, handlePaginationClick } from "../../helpers/paginations";
	import { displayNumber } from "../../helpers/general";

    export default {
        name: "Show",
        computed: {
            ...mapGetters(["categoriePrestation",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','isComptable','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },

            mCategory: function() {
                return this.categoriePrestation;
            },

            prestationColumns: function () {
                return [
                    {
                        label: this.$i18n.tc('message.name'),
                        field: 'nom',
                    },
                    {
                        label: this.$i18n.tc('message.price'),
                        field: 'prix',
                    }
                ];
            },

            prestationRows:function(){
                let cArray = [];
                _.forEach(this.categoriePrestation.prestations, function (prestation) {
                    cArray.push({
                        nom:prestation.nom,
                        prix:prestation.prix,
                        slug:prestation.slug
                    })
                })
                return cArray;
            },

        },

        data() {
            return {
                categorie_prestation: this.$route.params.categorie,
				filterCriteria: '',
				categoryPrestations: [],
				paginationObject: {},
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [10, 15, 20]
                },
            }
        },

		watch: {
			categoriePrestation: function (newValue, oldValue) {
				this.categoryPrestations = newValue.prestations
					.map(institution => ({
						slug: institution.slug,
						name: institution.nom,
						price: institution.prix,
					}));
			},

			categoryPrestations: function (newValue, oldValue) {
				this.paginationObject = pagination(newValue);
			},

			filterCriteria: function (newValue, oldValue) {
				this.handleFilter(newValue);
			}
		},

        methods: {

			handleOnAddClick() {
                this.$router.push({ name: 'add-prestation', query:{categorie_id: this.categoriePrestation.id} });
            },

			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},

			handleFilter(value) {
				if (value) {
					const newCategoryPrestations = this.categoryPrestations.filter(app => {
						let result = false;

						if (app.name) {
							result = result || app.name.toLowerCase().includes(value.toLowerCase());
						}

						return result;
					});

					this.paginationObject = pagination(newCategoryPrestations);
				} else {
					this.paginationObject = pagination(this.categoryPrestations);
				}
			},

			getCategoriePrestation() {
                let args = {
                    categorie_prestation: this.categorie_prestation,
                };
                this.$store.dispatch("getCategoriePrestation", {args});
            },

            onPrestationClick(slug) {
                this.$router.push({ name: 'prestation', params: { prestation: slug } });

            },
            deleteCategoriePrestation() {
                let args = {
                    categorie_prestation: this.categorie_prestation,
                };

                let successMessage = this.$i18n.t('message.categorieDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteCategoriePrestation', {args, successMessage, errorMessages})
            },
            updateCategoriePrestation:function () {
                this.$router.push({ name: 'edit-categorie-prestation', params: { categorie: this.categorie_prestation } });

            },

			_displayNumber: displayNumber,
        },
        mounted() {
            this.getCategoriePrestation();
        }
    }
</script>

<style scoped>

</style>
